module.exports = __webpack_public_path__ + "static/media/AW-60-VP-Icon.8af57f46.png";